"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FavoritesDialogContent = void 0;
var _mui = require("@ori-ui/mui");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
const FavoritesDialogContent = ({
  buttons,
  content,
  message,
  testId
}) => /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.Root, {
  "data-testid": testId,
  children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.Content, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Typography, {
      textAlign: "center",
      children: message
    }), content]
  }), buttons == null ? null : /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.Buttons, {
    children: buttons
  })]
});
exports.FavoritesDialogContent = FavoritesDialogContent;
//# sourceMappingURL=FavoritesDialogContent.js.map